//dependencies
import { Endpoint, Http } from "Application";
import { AppUrls } from "AppUrls";

//components

export class DeleteMentorAbsenceRequest {
    public id: Guid = "";
    public isAbsence: boolean = true;
}

export class DeleteMentorAbsenceEndpoint extends Endpoint<DeleteMentorAbsenceRequest, Response> {
    constructor() {
        super();
        this.verb(Http.Delete);
        this.path(AppUrls.Server.WeeklyRota.DeleteMentorRotaAbsence);
    }

    public async HandleRequestAsync(request: DeleteMentorAbsenceRequest): Promise<any> {
        return Promise.resolve(request);
    }

    public async HandleResponseAsync(responses: Response[]): Promise<any> {
        return Promise.resolve(responses);
    }
}
